/**
 * Meeting-Prep Agent configuration (self-contained — delete this folder to remove the feature).
 * To disable without deleting anything, set ENABLED to false.
 *
 * Mirrors the shipped Ask Clara (Copilot) config so the two agents stay consistent and this
 * folder remains independently removable. Same agent_manager service, different agent id.
 */

// Agent service base URL — identical resolution to Copilot:
// - localhost → talk to the locally-run agent_manager on :5099 (avoids cross-origin CORS/cookie).
// - deployed → same-origin under API_BASE_URL so the session cookie flows for per-user RBAC.
const isLocalhost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const AGENT_BASE_URL = isLocalhost
  ? 'http://localhost:5099'
  : `${process.env.API_BASE_URL || ''}agent-manager`;

// eslint-disable-next-line import/prefer-default-export
export const MEETING_PREP_CONFIG = {
  // Per-environment kill switch. Disables BOTH the button and the panel (fail-safe: OFF unless a
  // .env.* file explicitly sets MEETING_PREP_ENABLED=true). Enabled in dev/qa/uat for client
  ENABLED: process.env.MEETING_PREP_ENABLED === 'true',
  AGENT_BASE_URL,
  AGENT_ID: 'meeting_prep',

  /**
   * Roles that can see/use the Meeting-Prep briefing. Admin-only for now.
   * To add roles later (e.g. reviewers), append them here AND set the backend env
   * MEETING_PREP_ALLOWED_ROLES to the SAME list — the backend is the real security gate; this list
   * only controls who sees the button. Use the exact role strings the app stores on the user
   * (e.g. 'admin', 'reviewer', 'brand_owner', 'marcom').
   */
  ALLOWED_ROLES: ['admin'],

  /** Only workflows in this status expose the briefing. */
  TRIGGER_STATUS: 'in_discussion',

  /**
   * Per-user auth. Deployed same-origin: leave blank — `withCredentials` sends the logged-in
   * user's cookie for real per-user RBAC. Local-only fallback: paste a dev token for cross-origin.
   */
  AGENT_BEARER_TOKEN: '',
};
